import { useTranslation } from 'next-i18next';
import React from 'react';

import Container from './Container';
import Icon from './Icon';
import Typography from './Typography';

const Description: React.FC = () => {
  const { t } = useTranslation('property');
  return (
    <Container>
      <Icon />
      <Typography
        weight='light'
        color='blackCoral'
      >
        {t('realEstateDirectCreditParagraph')}
      </Typography>
    </Container>
  );
};

export default React.memo(Description);
